import src from "IMAGE";
export default { src, width: 540, height: 540, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAS0lEQVR42q3OIQoAIRRFUYdhGERQ0OQqLCa7S3ABLsHoBly3NxgMRj8cfrnhCXHrHihIvKcgoKCun+D3IKMtHQNxD34YWGg4fHfWTxzNBE6b1RMwAAAAAElFTkSuQmCC"};
